import React, { useState } from 'react';
import { IconChevronRight } from '@tabler/icons-react';
import GuestModal from './GuestModal';
import { TripInvite } from '../../../gql/graphql';

interface GuestRowProps {
  guest: TripInvite | null | undefined; // allow guest to be null or undefined
  guestNumber: number;
  bookingId: number;
  tripId: number;
}

const GuestRow: React.FC<GuestRowProps> = ({
  guest,
  guestNumber,
  bookingId,
  tripId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const isLead = guestNumber === 1;
  const displayText = isLead ? 'You' : (guest?.email ?? 'Not assigned');
  const isCompleted = Boolean(guest?.isCompleted);

  return (
    <>
      <button
        type="button"
        className="flex w-full justify-between items-center py-4"
        onClick={handleOpenModal}
      >
        <div className="flex flex-col items-start">
          <span className="text-neutral-800 font-semibold">
            {`Guest ${guestNumber}`}
          </span>
          <span className="text-neutral-500">{displayText}</span>
        </div>
        <div className="flex items-center">
          <div
            className={`flex py-1 px-2 mr-4 items-start gap-2 rounded ml-2 md:ml-4 ${
              isCompleted
                ? 'border border-status-success text-status-success'
                : 'border border-status-error text-status-error'
            }`}
          >
            <span className="text-sm font-semibold">
              {isCompleted ? 'Ready to go' : 'Action required'}
            </span>
          </div>
          <div>
            <IconChevronRight size={20} />
          </div>
        </div>
      </button>

      <GuestModal
        guestNumber={guestNumber}
        guestEmail={guest?.email ?? ''}
        inviteId={guest?.inviteId}
        magicLink={guest?.magicLink}
        bookingId={bookingId}
        tripId={tripId}
        open={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default GuestRow;
